import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Link from '../link';
import Checkmark from '../svgs/icons/checkmark';

const Icon = ({
    icon,
    area,
    text,
    href,
    target,
    rel,
    title,
    className,
    size,
    hasWrapper,
    onClick,
    style,
    checkmarkColor,
    checkmarkState,
    color,
    ...r
}) => {
    const classes = classNames('icon', className, {
        [`--icon-${size}`]: size,
        '--wrapper': hasWrapper,
        [`--${color}`]: color,
    });

    const getIcon = (icon) => {
        try {
            return require(`../svgs/icons/${icon}`).default;
        } catch (error) {
            return require(`../svgs/icons/club`).default;
        }
    };
    const RenderIcon = getIcon(icon);

    const icon_ =
        icon === 'checkmark' ? (
            <Checkmark
                className={classes}
                checkmarkColor={checkmarkColor}
                state={checkmarkState}
                isWrapped={hasWrapper}
                {...r}
            />
        ) : (
            <i className={classes} onClick={onClick} style={style} {...r}>
                <RenderIcon {...r} />
            </i>
        );

    return (
        <>
            {href ? (
                <Link
                    href={href}
                    title={title}
                    target={target}
                    {...(rel && { rel: rel.toString() })}
                >
                    {icon_}
                    {text ? <span>{text}</span> : ''}
                </Link>
            ) : (
                <>{icon_}</>
            )}
        </>
    );
};

Icon.propTypes = {
    /**
     * Componente del icono.
     */
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    /**
     * Texto del icono.
     */
    text: PropTypes.string,
    /**
     * Atributo href del link.
     */
    href: PropTypes.string,
    /**
     * Atributo target del link.
     */
    target: PropTypes.string,
    /**
     * Atributo rel del link.
     */
    rel: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    /**
     * Atributo title del link.
     */
    title: PropTypes.string,
    /**
     * Clases adicionales.
     */
    className: PropTypes.string,
    /**
     * Tamaño del icono.
     */
    size: PropTypes.oneOf(['s', 's2', 'm', 'l', 'xl', 'inherit']),
    /**
     * Flag, ¿tiene wrapper?
     */
    hasWrapper: PropTypes.bool,
    /**
     * Color del icono
     */
    color: PropTypes.oneOf([
        'light',
        'dark',
        'gray',
        'primary',
        'warning',
        'success',
        'danger',
        'violet',
    ]),
    /**
     * Color de checkmark (si aplica)
     */
    checkmarkColor: PropTypes.string,
    /**
     * Estado del checkmark (si aplica)
     */
    checkmarkState: PropTypes.bool,
};

Icon.defaultProps = {
    size: 'm',
};

export default Icon;
